import {
    parseCount,
} from './utils';

export const reactionMembersCache =
    new Map();

export const commentsCache =
    new Map();

export const getReactionCacheKey = (
    photoId,
    reaction = null
) => {
    return `${
        photoId
    }:${
        reaction || 'all'
    }`;
};

export const clearPhotoReactionCache = (
    photoId
) => {
    const keyPrefix =
        `${photoId}:`;

    Array.from(
        reactionMembersCache.keys()
    ).forEach((key) => {
        if (
            key.startsWith(
                keyPrefix
            )
        ) {
            reactionMembersCache.delete(
                key
            );
        }
    });
};

const getCommentCacheKey = (
    photoId
) => String(photoId);

export const getCachedComments = (
    photoId
) => {
    return commentsCache.get(
        getCommentCacheKey(
            photoId
        )
    ) ?? null;
};

export const setCachedComments = (
    photoId,
    cachedData
) => {
    commentsCache.set(
        getCommentCacheKey(
            photoId
        ),
        cachedData
    );
};

export const addCommentToCache = (
    photoId,
    comment,
    commentCount
) => {
    const cachedData =
        getCachedComments(
            photoId
        );

    if (!cachedData) {
        setCachedComments(
            photoId,
            {
                comments: [
                    comment,
                ],

                nextPageUrl: null,

                hasMorePages: false,

                commentCount:
                    parseCount(
                        commentCount
                    ),
            }
        );

        return;
    }

    const alreadyCached =
        cachedData.comments.some(
            (cachedComment) =>
                String(
                    cachedComment.id
                )
                === String(
                    comment.id
                )
        );

    setCachedComments(
        photoId,
        {
            ...cachedData,

            comments:
                alreadyCached
                    ? cachedData.comments
                    : [
                        ...cachedData.comments,
                        comment,
                    ],

            commentCount:
                parseCount(
                    commentCount
                ),
        }
    );
};

export const updateCommentInCache = (
    photoId,
    updatedComment
) => {
    const cachedData =
        getCachedComments(
            photoId
        );

    if (!cachedData) {
        return;
    }

    setCachedComments(
        photoId,
        {
            ...cachedData,

            comments:
                cachedData.comments.map(
                    (cachedComment) =>
                        String(
                            cachedComment.id
                        )
                        === String(
                            updatedComment.id
                        )
                            ? updatedComment
                            : cachedComment
                ),
        }
    );
};

export const removeCommentFromCache = (
    photoId,
    commentId,
    commentCount
) => {
    const cachedData =
        getCachedComments(
            photoId
        );

    if (!cachedData) {
        return;
    }

    setCachedComments(
        photoId,
        {
            ...cachedData,

            comments:
                cachedData.comments.filter(
                    (cachedComment) =>
                        String(
                            cachedComment.id
                        )
                        !== String(
                            commentId
                        )
                ),

            commentCount:
                parseCount(
                    commentCount
                ),
        }
    );
};